




















import {Component, Vue} from "vue-property-decorator";
import PickingListTable from "../../pickinglists/shared/component/PickingListTable/index.vue";
import HistoryStockOutSearch from "@/modules/warehouses/HistoryStockOut/components/Search/index.vue";
import PickingListDetail from "@/modules/pickinglists/shared/component/PickingListDetail/index.vue";
import PickingListPrint from "@/modules/pickinglists/shared/component/PickingListPrint/index.vue";
import {getPublicPath} from "@/shared/services/helper/utils";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import EnumLabel from "@/shared/components/EnumSelector/components/Label.vue";
import PLDeliveryTable from "@/modules/pickinglistdeliveries/shared/component/PickingListDeliveryTable/index.vue";
import {PickingListDeliveryEmployeeParams, PickingListDeliveryStore} from "@/modules/pickinglistdeliveries";
import PLDeliveryPrint from "@/modules/pickinglistdeliveries/shared/component/PickingListDeliveryPrint/index.vue";
import PLDeliveryDetail from "@/modules/pickinglistdeliveries/shared/component/PickingListDeliveryDetail/index.vue";
import {PickingListDeliveryType} from "@/enums/type";
import PLDeliverySearchEmployee
    from "@/modules/pickinglistdeliveries/shared/component/PickingListDeliverySearchEmployee/index.vue";

@Component({
    name: "StockOutDeliveryForEmployee",
    components: {
        PLDeliverySearchEmployee,
        PLDeliveryDetail,
        PLDeliveryPrint,
        PLDeliveryTable,
        EnumLabel, PickingListPrint, PickingListDetail, HistoryStockOutSearch, PickingListTable
    }
})
export default class extends mixins(CommonMixin) {
    visible = false;
    id = null;
    printObj = {
        id: "picking-list-deliveries-print",
        popTitle: 'Logistic',
        extraCss: `${getPublicPath()}assets/css/print.css`,
    };

    created() {
        PickingListDeliveryStore.updatePickingListDeliveryParams({
            ...new PickingListDeliveryEmployeeParams(),
            type: PickingListDeliveryType.Employee
        });
        PickingListDeliveryStore.listPickingListDeliveryForEmployee(PickingListDeliveryStore.params);
    }

    get pickingListDeliveries() {
        return PickingListDeliveryStore.ids.map((id: number) => PickingListDeliveryStore.data[id]);
    }

    onChangePage(pagination) {
        PickingListDeliveryStore.listPickingListDeliveryForEmployee({
            ...PickingListDeliveryStore.params,
            page: pagination.current,
            limit: pagination.pageSize
        })
    }

    async seeDetail(id: number) {
        if (isNaN(id)) return;
        this.id = id as any;
        await PickingListDeliveryStore.listBillLadingByPickingListDelivery(this.id);
        this.visible = true;
    }

    async deletePickingListDelivery(id: number) {
        if (isNaN(id)) return;
        try {
            await PickingListDeliveryStore.deletePickingListDelivery(id);
            this.$message.success("Xóa bảng kê thành công");
        } catch (e) {
            this.$message.error(e?.response?.data?.message || 'Xóa bảng kê thất bại');
        }
    }

    createDeliveryEmployee() {
        this.$router.push({name: "createDeliveryEmployee"});
    }
}
